<script setup lang="ts">
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import GoldenWheel from '@/assets/images/golden-wheel.png'
import { useConfig } from '@/composables/game/config'

defineProps<{
  show: boolean,
}>()

defineEmits<{
  (e: 'hide'): void
}>()

const { config } = useConfig()

</script>
<template>
  <TheBottomSheet
    :show="show"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col gap-y-6">
      <div class="flex flex-col gap-y-1">
        <h2 class="text-solid-white text-lg -tracking-[0.36px] font-bold">
          <T
            key-name="fortune_wheel.info.how_works.title"
            default-value="🎡 How it works?"
          />
        </h2>
        <p class="text-base font-medium text-white/60 whitespace-pre-line">
          <T
            key-name="fortune_wheel.info.how_works.description"
            default-value="Get {count} free spins daily to win exciting rewards! Earn more spins by completing tasks or buying them with stars."
            :params="{count: config.game.fortuneWheel.extraSpin.daily.amount}"
          />
        </p>
      </div>
      <div class="flex flex-col gap-y-1">
        <h2 class="text-solid-white text-lg -tracking-[0.36px] font-bold">
          <T
            key-name="fortune_wheel.info.what_earn.title"
            default-value="💰  What can you earn?"
          />
        </h2>
        <p class="text-base font-medium text-white/60 whitespace-pre-line">
          <T
            key-name="fortune_wheel.info.what_earn.description"
            :default-value="`Win Dropee Coins or $DROPEE. \nNew rewards are coming soon!`"
          />
        </p>
      </div>
      <div class=" flex flex-col gap-y-1">
        <div class="flex gap-x-3 text-solid-white text-lg -tracking-[0.36px] font-bold">
          <img
            :src="GoldenWheel"
            class="size-6"
          >
          <T
            key-name="fortune_wheel.info.golden_wheel.title"
            default-value="Unlock the Golden Wheel"
          />
        </div>
        <p class="text-base font-medium text-white/60 whitespace-pre-line">
          <T
            key-name="fortune_wheel.info.golden_wheel.description"
            default-value="Keep a 7-day spin streak to unlock the Golden Wheel and win bigger rewards!"
          />
        </p>
      </div>
      <div class="flex flex-col gap-y-1">
        <h2 class="text-solid-white text-lg -tracking-[0.36px] font-bold">
          <T
            key-name="fortune_wheel.info.prize_multipliers.title"
            default-value="🤪 Prize Multipliers"
          />
        </h2>
        <p class="text-base font-medium text-white/60 whitespace-pre-line">
          <T
            key-name="fortune_wheel.info.prize_multipliers.description"
            default-value="Use Prize Multipliers to multiply your rewards! Only applies to in-game rewards — not $DROPEE tokens."
          />
        </p>
      </div>
    </div>
  </TheBottomSheet>
</template>
